import React from "react";
import { Box, Typography } from "@mui/material";
import ToggleRow from "../../../common/ToggleRow";
import AgentConfigSection from "../AgentConfigSection";
import PlanTemplateEditor from "../../ManagedRunPolicy/PlanTemplateEditor";
import { NODE_UI } from "../../../NodeUI";
import { defaultHarnessDraft, emptyStep } from "../harnessModel";

export default function HarnessTab({ harness, setHarness, setHarnessField }) {
  const slice = harness || { enabled: false, goal: "", tasks: [] };
  const steps = slice.tasks || [];

  const handleToggle = (checked) => {
    if (checked && steps.length === 0) {
      setHarness(defaultHarnessDraft());
      return;
    }
    setHarnessField("enabled", checked);
  };

  const handleStepChange = (index, nextStep) =>
    setHarness((prev) => {
      const tasks = [...(prev.tasks || [])];
      tasks[index] = nextStep;
      return { ...prev, tasks };
    });

  const handleStepRemove = (index) =>
    setHarness((prev) => {
      const tasks = [...(prev.tasks || [])];
      tasks.splice(index, 1);
      return { ...prev, tasks };
    });

  const handleAddStep = () =>
    setHarness((prev) => ({ ...prev, tasks: [...(prev.tasks || []), emptyStep()] }));

  return (
    <AgentConfigSection id="harness">
      <ToggleRow
        checked={!!slice.enabled}
        onChange={handleToggle}
        title="Self-driving harness"
        description="Seed a standing, time-bound plan onto every new chat with this agent. Time-bound steps get scheduled wakes so the agent keeps working toward the goal without manual prompting."
      />

      {slice.enabled ? (
        <Box sx={{ mt: 2 }}>
          <Typography
            sx={{
              fontSize: NODE_UI.fontSize.caption,
              color: "text.secondary",
              lineHeight: 1.4,
              mb: 1.5,
            }}
          >
            Requires the planner and scheduling tools (Plan tasks, Update task queue,
            Schedule message) on the Tools tab for the agent to advance and wait on its own.
          </Typography>

          <PlanTemplateEditor
            goal={slice.goal || ""}
            tasks={steps}
            onGoalChange={(next) => setHarnessField("goal", next)}
            onStepChange={handleStepChange}
            onStepRemove={handleStepRemove}
            onAddStep={handleAddStep}
            goalHelperText="The outcome every chat with this agent is driving toward."
          />
        </Box>
      ) : null}
    </AgentConfigSection>
  );
}
